import { render, staticRenderFns } from "./dismissal_note.vue?vue&type=template&id=3b9aea02&"
import script from "./dismissal_note.vue?vue&type=script&lang=js&"
export * from "./dismissal_note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports